import request from './request'

export async function selRotograph (params) {
  return request({
    url: '/web/base/selRotograph', //官网轮播图
    method: 'GET',
    params
  })
}
export async function getArticleBySortName (params) {
  return request({
    url: '/web/article/getArticleBySortName', //资讯
    method: 'GET',
    params
  })
}
export async function selSort (params) {
  return request({
    url: '/web/product/selSort', //商品相关
    method: 'GET',
    params
  })
}

// export async function selRotograph (params) {
//   return request({
//     url: '/1.json', //官网轮播图
//     method: 'GET',
//     params
//   })
// }
// export async function getArticleBySortName (params) {
//   return request({
//     url: '/3.json', //资讯
//     method: 'GET',
//     params
//   })
// }
// export async function selSort (params) {
//   return request({
//     url: '/2.json', //商品相关
//     method: 'GET',
//     params
//   })
// }